module.exports = __webpack_public_path__ + "img/room-rewards.288cf8d8.jpg";